import HttpMessage, { ROOT_URL } from './HttpMessage';

class CitiesService {

  static async fetchCities() {
    const message = {
      route: `${ROOT_URL}/cities`,
      method: 'GET',
      body: null,
      header: null
    };

    const data = await HttpMessage.sendMessage(message);

    const citiesList = [];
    if (data.status === 'success') {
      data.cities.forEach(val => {
        const obj = {};
        obj.cityId = val.id;
        obj.name = val.name;
        obj.state = val.state;
        obj.country = val.country;
        obj.smsEnabled = val.sms_enabled;
        obj.voiceEnabled = val.voice_enabled;

        citiesList.push(obj);
      });
    }

    return citiesList;
  }
}

export default CitiesService;
